import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import FormSection from "../../Common/FormSection";
import CloseIcon from "../../Common/CloseIcon";
import AddPicture from "../../Common/AddPicture";
import CustomButton from "../../Common/CustomButton";
import MultipleFormSection from "./MultipleFormSection";

//import { formatPhone } from "../../../utils/form";
import { getAttributeValue, getAttributeValues } from "../../../utils/profile";
import { getAttributeName } from "../../../utils/attributes";


import { LANGUAGES } from "../../../constants/common";

import colors from "../../../assets/style/colors";
//import images from "../../../assets/img/images";
import AddPictureGallery from "../../Common/AddPictureGallery";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const styles = {
  dialogTitle: {
    fontSize: "1.142em",
    color: colors.black87,
    textAlign: "center",
    textTransform: "uppercase",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: "12px",
    "& img": {
      cursor: "pointer",
    },
  },
  label: {
    color: colors.black54,
    fontSize: "1em",
  },
};

const HumanFormExpress = (props) => {
  const {
    classes,
    createProfile,
    data,
    lov,
    handleChange,
    validForm,
    errors,
    language,
    profileValidationRules,
    flow
  } = props;

  const [enroll, setEnroll] = React.useState(false);

  const isValid = (id) => {
    if (validForm && validForm[id]) {
      return true;
    }
    return false;
  };

  const isValidForm = () => {
    return (
      get(validForm, [31]) && get(validForm, [32]) && get(validForm, ["tag"])
      // &&
      // (get(validForm, [33]) || get(validForm, [34]))
    );
  };

  if (flow === "newAccount"){
    return (
      <Grid
        container
        direction="column"
        style={{
          minHeight: "775px",
          minWidth: "308px",
        }}
      >
        <Grid item style={{ paddingTop: "12px" }}>
          <Grid container alignItems="center">
            <Grid item xs={2} />
            <Grid item xs className={classes.dialogTitle}>
              {I18n.get("profiles_newProfile")}
            </Grid>
            <Grid item xs={2} className={classes.closeBtn}>
              <CloseIcon closeFunction={props.close} />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs
          style={{
            maxHeight: "calc(100vh - 120px)",
            overflow: "auto",
            padding: "24px",
          }}
        >
          <Grid container direction="column">
            <FormSection
              formValue={[getAttributeValue(data, 31)]}
              setFormValue={handleChange}
              title2={getAttributeName(31)}
              id={31}
              options={{ required: true, redBorder: !isValid(31) }}
            />
            <FormSection
              formValue={[getAttributeValue(data, 32)]}
              setFormValue={handleChange}
              title2={getAttributeName(32)}
              id={32}
              options={{ required: true, redBorder: !isValid(32) }}
            />
            <FormSection
              formValue={[getAttributeValue(data, 195)]}
              setFormValue={handleChange}
              title2={getAttributeName(195)}
              id={195}
              options={{
                required: get(profileValidationRules, ["emailRequired"]),
                errorMsg: errors[195],
                redBorder:
                  (get(profileValidationRules, ["emailRequired"]) ||
                    getAttributeValue(data, 195)) &&
                  !isValid(195),
              }}
            />
            <MultipleFormSection
              id={34}
              typeId={194}
              title2={getAttributeName(34)}
              data={getAttributeValues(data, 34)}
              setFormValue={handleChange}
              lov={lov}
              language={language}
              errorMsg={errors[34]}
              required={get(profileValidationRules, ["phoneRequired"])}
              options={{
                errorMsg: errors[34],
                redBorder: !isValid(34),
              }}
            />
            {/* <Grid
              item
              xs
              className={classes.sectionCol}
              style={{
                backgroundColor: colors.lightGrey,
                paddingTop: "0px",
                paddingBottom: "0px",
                marginBottom: "26px",
              }}
            >
              <Grid container direction="column">
                <Grid
                  item
                  style={{
                    color: colors.black54,
                    fontStyle: "italic",
                    margin: "5px 0px 12px 0px",
                    fontSize: "0.875em",
                  }}
                >
                  {(isValid(33) || isValid(34)) &&
                    (!getAttributeValue(data, 34) || isValid(34)) &&
                    (!getAttributeValue(data, 33) || isValid(33)) && (
                      <img
                        src={images.successIcon}
                        width="12px"
                        alt="success"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                  {I18n.get("profiles_atLeastOneRequired")}
                </Grid>
                <FormSection
                  formValue={[formatPhone(getAttributeValue(data, 34) || "")]}
                  setFormValue={(id, index, value) =>
                    handleChange(
                      id,
                      index,
                      parseInt(
                        value
                          .substring(0, 12 - value.length > 0 ? value.length : 12)
                          .split("-")
                          .join("")
                      )
                    )
                  }
                  title2={getAttributeName(34)}
                  id={34}
                  options={{
                    required: true,
                    errorMsg: errors[34],
                    redBorder:
                      (!isValid(34) && !isValid(33)) ||
                      (Boolean(getAttributeValue(data, 34)) && !isValid(34)),
                  }}
                />
                <FormSection
                  formValue={[getAttributeValue(data, 33)]}
                  setFormValue={handleChange}
                  title2={getAttributeName(33)}
                  id={33}
                  options={{
                    required: true,
                    errorMsg: errors[33],
                    redBorder:
                      (!isValid(33) && !isValid(34)) ||
                      (Boolean(getAttributeValue(data, 33)) && !isValid(33)),
                  }}
                  noMarginBottom
                />
              </Grid>
            </Grid>
            */}
            <FormSection
              formValue={[data.sys_tag_id]}
              setFormValue={handleChange}
              title="tag"
              id="sys_tag_id"
              type="select"
              options={{
                required: true,
                redBorder: !isValid("sys_tag_id"),
                comboBox: true,
                options:
                  lov.tag &&
                  lov.tag.map((t) => ({
                    id: t.id,
                    name: t["name_" + language],
                  })),
              }}
            />
            <Grid item style={{ minHeight: "110px" }}>
              <Grid
                container
                alignItems="center"
                style={{ marginBottom: "16px" }}
              >
                <Grid item className="text-87 bold-500">
                  {I18n.get("site_photos")}
                </Grid>
                <Grid item>
                  <AddPicture
                    id="express_profile_creation"
                    pictures={get(props, ["localPhotos"])}
                    setPictures={(p) => props.setLocalPhotos(p)}
                  />
                </Grid>
              </Grid>
              <AddPictureGallery
                photos={get(props, ["localPhotos"])}
                setPhotos={(p) => props.setLocalPhotos(p)}
              />
            </Grid>
            <Grid item style={{ marginTop: "23px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enroll}
                    onChange={() => setEnroll(!Boolean(enroll))}
                    name="enroll"
                    color="primary"
                  />
                }
                label={I18n.get("site_frEnroll")}
                classes={{ label: classes.label }}
              />
            </Grid>
            <Grid item style={{ textAlign: "center", margin: "31px 0px 0px" }}>
              <CustomButton
                color="primary"
                onClick={props.close}
                style={{
                  marginRight: "10px",
                }}
              >
                {I18n.get("site_cancel")}
              </CustomButton>
              <CustomButton
                color="primary"
                variant="contained"
                onClick={async () => {createProfile(enroll);}}
                style={{ marginLeft: "10px" }}
                disabled={!isValidForm()}
              >
                {I18n.get("site_create")}
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid
        container
        direction="column"
        style={{
          minHeight: "800px",
          minWidth: "308px",
        }}
      >
        <Grid item style={{ paddingTop: "12px" }}>
          <Grid container alignItems="center">
            <Grid item xs={2} />
            <Grid item xs className={classes.dialogTitle}>
              {I18n.get("profiles_newProfile")}
            </Grid>
            <Grid item xs={2} className={classes.closeBtn}>
              <CloseIcon closeFunction={props.close} />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs
          style={{
            maxHeight: "calc(100vh - 120px)",
            overflow: "auto",
            padding: "24px",
          }}
        >
          <Grid container direction="column">
            <FormSection
              formValue={[getAttributeValue(data, 31)]}
              setFormValue={handleChange}
              title2={getAttributeName(31)}
              id={31}
              options={{ required: true, redBorder: !isValid(31) }}
            />
            <FormSection
              formValue={[getAttributeValue(data, 32)]}
              setFormValue={handleChange}
              title2={getAttributeName(32)}
              id={32}
              options={{ required: true, redBorder: !isValid(32) }}
            />
            <FormSection
              formValue={[getAttributeValue(data, 195)]}
              setFormValue={handleChange}
              title2={getAttributeName(195)}
              id={195}
              options={{
                required: get(profileValidationRules, ["emailRequired"]),
                errorMsg: errors[195],
                redBorder:
                  (get(profileValidationRules, ["emailRequired"]) ||
                    getAttributeValue(data, 195)) &&
                  !isValid(195),
              }}
            />
            <MultipleFormSection
              id={34}
              typeId={194}
              title2={getAttributeName(34)}
              data={getAttributeValues(data, 34)}
              setFormValue={handleChange}
              lov={lov}
              language={language}
              errorMsg={errors[34]}
              required={get(profileValidationRules, ["phoneRequired"])}
              options={{
                errorMsg: errors[34],
                redBorder: !isValid(34),
              }}
            />
            {/* <Grid
              item
              xs
              className={classes.sectionCol}
              style={{
                backgroundColor: colors.lightGrey,
                paddingTop: "0px",
                paddingBottom: "0px",
                marginBottom: "26px",
              }}
            >
              <Grid container direction="column">
                <Grid
                  item
                  style={{
                    color: colors.black54,
                    fontStyle: "italic",
                    margin: "5px 0px 12px 0px",
                    fontSize: "0.875em",
                  }}
                >
                  {(isValid(33) || isValid(34)) &&
                    (!getAttributeValue(data, 34) || isValid(34)) &&
                    (!getAttributeValue(data, 33) || isValid(33)) && (
                      <img
                        src={images.successIcon}
                        width="12px"
                        alt="success"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                  {I18n.get("profiles_atLeastOneRequired")}
                </Grid>
                <FormSection
                  formValue={[formatPhone(getAttributeValue(data, 34) || "")]}
                  setFormValue={(id, index, value) =>
                    handleChange(
                      id,
                      index,
                      parseInt(
                        value
                          .substring(0, 12 - value.length > 0 ? value.length : 12)
                          .split("-")
                          .join("")
                      )
                    )
                  }
                  title2={getAttributeName(34)}
                  id={34}
                  options={{
                    required: true,
                    errorMsg: errors[34],
                    redBorder:
                      (!isValid(34) && !isValid(33)) ||
                      (Boolean(getAttributeValue(data, 34)) && !isValid(34)),
                  }}
                />
                <FormSection
                  formValue={[getAttributeValue(data, 33)]}
                  setFormValue={handleChange}
                  title2={getAttributeName(33)}
                  id={33}
                  options={{
                    required: true,
                    errorMsg: errors[33],
                    redBorder:
                      (!isValid(33) && !isValid(34)) ||
                      (Boolean(getAttributeValue(data, 33)) && !isValid(33)),
                  }}
                  noMarginBottom
                />
              </Grid>
            </Grid>
            */}
            <FormSection
              formValue={[data.sys_tag_id]}
              setFormValue={handleChange}
              title="tag"
              id="sys_tag_id"
              type="select"
              options={{
                required: true,
                redBorder: !isValid("sys_tag_id"),
                comboBox: true,
                options:
                  lov.tag &&
                  lov.tag.map((t) => ({
                    id: t.id,
                    name: t["name_" + language],
                  })),
              }}
            />
            <Grid item style={{ minHeight: "110px" }}>
              <Grid
                container
                alignItems="center"
                style={{ marginBottom: "16px" }}
              >
                <Grid item className="text-87 bold-500">
                  {I18n.get("site_photos")}
                </Grid>
                <Grid item>
                  <AddPicture
                    id="express_profile_creation"
                    pictures={get(props, ["localPhotos"])}
                    setPictures={(p) => props.setLocalPhotos(p)}
                  />
                </Grid>
              </Grid>
              <AddPictureGallery
                photos={get(props, ["localPhotos"])}
                setPhotos={(p) => props.setLocalPhotos(p)}
              />
            </Grid>
            <Grid item style={{ marginTop: "23px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enroll}
                    onChange={() => setEnroll(!Boolean(enroll))}
                    name="enroll"
                    color="primary"
                  />
                }
                label={I18n.get("site_frEnroll")}
                classes={{ label: classes.label }}
              />
            </Grid>
            <Grid item style={{ textAlign: "center", margin: "31px 0px 0px" }}>
              <CustomButton
                color="primary"
                onClick={props.close}
                style={{
                  marginRight: "10px",
                }}
              >
                {I18n.get("site_cancel")}
              </CustomButton>
              <CustomButton
                color="primary"
                variant="contained"
                onClick={() => createProfile(enroll)}
                style={{ marginLeft: "10px" }}
                disabled={!isValidForm()}
              >
                {I18n.get("site_create")}
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
};

HumanFormExpress.propTypes = {
  section: PropTypes.oneOf(["main", "secondary"]).isRequired,
  data: PropTypes.object.isRequired,
  lov: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  validForm: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  language: PropTypes.oneOf(LANGUAGES),
};

export default withStyles(styles)(HumanFormExpress);
